import React from 'react';

import { BaseIconProps } from './';

export const PlusCircle = ({ fill }: BaseIconProps) => (
  <g transform="matrix(49.090909,0,0,49.090909,-13109.727,-14824.227)">
    <path
      d="M 11,0 A 11,11 0 1 0 22,11 11.016,11.016 0 0 0 11,0 Z"
      transform="rotate(90,-6.4625,295.5125)"
      fill={fill}
      stroke="rgba(0,0,0,0)"
      strokeWidth={2}
    />
    <g>
      <rect
        width="10.678"
        height="2.342"
        transform="rotate(90,-14.2245,293.4275)"
        fill="#ffffff"
        stroke="rgba(0,0,0,0)"
        strokeWidth={2}
        x={0}
        y={0}
      />
      <rect
        width="10.678"
        height="2.342"
        transform="translate(272.693,311.822)"
        fill="#ffffff"
        stroke="rgba(0,0,0,0)"
        strokeWidth={2}
        x={0}
        y={0}
      />
    </g>
  </g>
);
